export const VIEWING_RELATIONSHIP_INDEX_CLIENT = -1
export const VIEWING_RELATIONSHIP_INDEX_DOCUMENTS = -2
